import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ContentByLabelMacroRendererProps } from '../src/ContentByLabelMacroRenderer.tsx';

export const ContentByLabelMacroHandler: LoadableType<ContentByLabelMacroRendererProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContentByLabelMacro" */ '../src/ContentByLabelMacroRenderer.tsx'
				)
			).ContentByLabelMacroRenderer,
	});
